/**
 * Localization messages for KpiTiles component
 */
import sharedMessages from '../../shared/messages/sharedMessages';
import { mergeInvertedMessages } from '../../utils/localization';

const componentMessages = {
  // KPI tile titles (dashboard metrics)
  'Active Recommended Roles': 'roleRecs.kpiTiles.activeRecommendedRoles',
  'Total Active Roles': 'roleRecs.kpiTiles.totalActiveRoles',

  // KPI tile subtitles (dynamic content with counts)
  '{count} Assigned access from these Roles':
    'roleRecs.kpiTiles.assignedAccessFromRoles',
} as const;

const invertedMessages = mergeInvertedMessages(
  sharedMessages,
  componentMessages
);

export type KpiTilesMessage = keyof typeof invertedMessages;

export default invertedMessages;
